package ui.app.assign.detail.kindergarten.preview

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import common.frontend.api.canLayerBottomDelete
import common.frontend.api.canLayerBottomEdit
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.navTo_AppKindergartenEditorUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import ui.snackBarStateGlobal

@VM
class AppKindergartenPreviewVM : NavigationViewModel() {

    private lateinit var scopeUi: AppKindergartenPreviewScope

    var state by mutableDataState<AppKindergartenPreviewScope.Wrapper>()
        private set

    sealed interface Action {

        data class Archive(val doArchive: Boolean) : Action
        data object Edit : Action
        data class Delete(val withLogo: Boolean, val withContent: Boolean) : Action

        companion object {
            @Composable
            fun rememberAction(vm: AppKindergartenPreviewVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is Delete -> vm.delete(act.withLogo, act.withContent)
                            is Archive -> vm.archive(act.doArchive)
                            is Edit -> vm.scopeUi.nav.navTo_AppKindergartenEditorUI(vm.scopeUi.args)
                        }
                    }
                }
            }
        }
    }

    private fun archive(archive: Boolean) {
        scope.launch {
            runCatching {
                Repository.api.app.archive(
                    companyId = scopeUi.args.companyId,
                    appId = scopeUi.args.appId,
                    doArchive = archive
                )
            }.onFailure {
                snackBarStateGlobal.showSnackbar(
                    message = it.message ?: "Archivation state change failure",
                    withDismissAction = true
                )
                it.printStackTrace()
            }.onSuccess {
                scopeUi.nav.up()
            }
        }
    }


    fun init(scopeUi: AppKindergartenPreviewScope) {
        this.scopeUi = scopeUi
        state = DataState.Loading()
        scope.launch {
            runCatching {
                val app = Repository.api.app.single(scopeUi.args.companyId, scopeUi.args.appId)
                state = DataState.Result(
                    AppKindergartenPreviewScope.Wrapper(
                        canEdit = scopeUi.login.canLayerBottomEdit(scopeUi.args.companyId),
                        canDelete = scopeUi.login.canLayerBottomDelete(scopeUi.args.companyId),
                        data = app
                    )
                )
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error("Connection fail ${it.message}")
            }
        }

    }

    private fun delete(withLogo: Boolean, withContent: Boolean) {
        scope.launch {
            state.entry?.data?.apply {
                runCatching {
                    Repository.api.app.delete(scopeUi.args.companyId, id, withLogo, withContent)
                }.onSuccess {
                    scopeUi.nav.up()
                }.onFailure {
                    snackBarStateGlobal.showSnackbar(
                        it.message ?: "Fail to delete",
                        withDismissAction = true
                    )
                    it.printStackTrace()
                }
            }

        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }
}
